import React, { useEffect } from "react";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import AgriPixLogo from '../../assets/icons/AgriPix_logo.svg';
import { useAppDispatch } from '../../storeHook';
import { deleteToken } from '../../reduxActions/tokenSlice';
import policyIcon from '../../assets/images/policyIcon.png';
import policyPDF from '../../assets/pdfs/UPL AI Acceptable Usage Policy.pdf';
import {
  appLogEvent,
  CUSTOM_EVENTS,
} from '../../utils/analytics';
import { useGetUserDetailsQuery } from '../../services/user';
import { Users } from '../../pages/users';
import { getFormattedUserName } from '../../utils/functions/common';
import { resetAuthUser } from '../../services/slices/authUserSlice';
import { AppCircularProgress } from '../AppCircularProgress';
import AppTheme from './appTheme';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import { useLogoutMutation } from '../../services/auth';
// import { LanguageSelect } from '../languageSelect';
import Policy from '../policyForm/policy';
import { useAcceptMainPolicyMutation } from '../../services/agrocraftArtisan';

export default function AppHeader() {
  const [anchorEl, setAnchorEl] =
    React.useState<null | HTMLElement>(null);

  const dispatch = useAppDispatch();

  const [logout] = useLogoutMutation();

  const [openPolicy, setOpenPolicy] = React.useState(false);
  const [isPolicyAccepted, setIsPolicyAccepted] = React.useState(false);
  const [acceptPolicy] = useAcceptMainPolicyMutation();
  const handleMenu = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (localStorage.getItem("isPolicy") === "false") {
      setOpenPolicy(true);
      setAnchorEl(null);
      setIsPolicyAccepted(true)
    }
  }, []);

  const handlePolicyClick = () => {
    setOpenPolicy(true);
    setAnchorEl(null);
    // If isPolicy is false, user hasn't accepted yet, so show "Accept & Continue"
    const policyStatus = localStorage.getItem("isPolicy");
    setIsPolicyAccepted(policyStatus === "false");
  };
 
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogoutClick = async () => {
    appLogEvent(CUSTOM_EVENTS.LOG_OUT);
    try {
      await logout().unwrap();
    } catch (error) {
      console.error('Logout error:', error);
    }
    localStorage.removeItem('authToken');
    localStorage.removeItem('isPolicy');
    localStorage.removeItem('LoggedInDetails');
    localStorage.removeItem('isLogin');
    dispatch(deleteToken());
    dispatch(resetAuthUser());
    window.location.href = '/sign-in';
  };

  const handlePolicyAccept = async () => {
    try {
      await acceptPolicy().unwrap();
      localStorage.setItem("isPolicy", "true");
      setOpenPolicy(false);
      setIsPolicyAccepted(true);
    } catch (err) {
      console.error("Policy API failed", err);
    }
    setOpenPolicy(false);
  };

  const [isLoadingUsersList, setIsLoadingUsersList] =
    React.useState(false);
  const { data: userDetails } = useGetUserDetailsQuery();
  const userName = getFormattedUserName(userDetails?.full_name);
  const navigate = useNavigate();
  const handleBackNavigation = () => {
    navigate('/');
  };
  return (
    <div
      style={{ minHeight: '64px' }}
      className="header-container">
      {isLoadingUsersList && <AppCircularProgress />}
      <AppBar position="relative" className="app-bar">
        <Toolbar className="flex fleflex md:ml-auto justify-between md:justify-end w-full items-centerx-col md:flex-row">
          <img
            src={AgriPixLogo}
            className="w-[159.49px] h-[45.25px] object-contain cursor-pointer"
            onClick={handleBackNavigation}
          />
          <div className="flex md:ml-auto justify-between md:justify-end w-full items-center">
            <AppTheme />
            {/* <LanguageSelect /> */}
            <div className="my-auto md:ml-6">
              <span
                className="profile-icon"
                style={{
                  padding: '4px',
                  borderRadius: '5px',
                  marginRight: '7px',
                  cursor: 'pointer',
                }}
                onClick={handleMenu}>
                {userName?.shortName || 'CU'}
              </span>
              <Typography
                className="user-name"
                variant="h6"
                component="span"
                sx={{
                  flexGrow: 1,
                  fontWeight: 600,
                  fontSize: '13px',
                }}>
                {userName?.name || 'Current User'}
              </Typography>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                <div>
                  <MenuItem onClick={handlePolicyClick}>
                    <ListItemIcon>
                      <img
                        src={policyIcon}
                        alt="policy-icon"
                        className="w-5 h-5"
                      />
                    </ListItemIcon>{' '}
                    AI Usage Policy
                  </MenuItem>
                  <MenuItem onClick={onLogoutClick}>
                    <ListItemIcon>
                      <PowerSettingsNewIcon />
                    </ListItemIcon>{' '}
                    Logout
                  </MenuItem>
                  {userDetails?.role === 'admin' && (
                    <Users
                      closeAnchorEle={handleClose}
                      setIsLoadingUsersList={
                        setIsLoadingUsersList
                      }
                    />
                  )}
                </div>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Policy
        open={openPolicy}
        pdfFile={policyPDF}
        onClose={() => setOpenPolicy(false)}
        handleOnclickSubmit={handlePolicyAccept}
        isPolicyFirst={isPolicyAccepted}
        heading='AI Usage Policy'
      />
    </div>
  );
}
